import React from "react";
import Link from "next/link";
import Image from "next/future/image";
import { useRouter } from "next/router";
import { Col } from "react-bootstrap";
import { getFullDate } from "src/helpers/functions";

const BlogCard = ({ blog, index }) => {
  const { locale } = useRouter();
  const { image, title, description, admin, created_at, id, slug } = blog;

  return (
    <Col xs={12} sm={6} md={6} lg={4}>
      <div className="block">
        <div className="block-img">
          <Link href={`/blogs/${slug}`}>
            <a></a>
          </Link>
          <Image
            src={image}
            alt="blog-img"
            width={1920}
            height={1080}
            loading="lazy"
            quality={100}
          />
        </div>
        <div className="person">
          <p className="created-at">{getFullDate(created_at, locale)}</p>
        </div>
        <div className="content">
          <Link href={`/blogs/${slug}`}>
            <a className="title">
              {title?.[locale].length > 50
                ? title?.[locale].slice(0, 50) + "..."
                : title?.[locale].slice(0, 50)}
            </a>
          </Link>

          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: description[locale] || "",
            }}
          ></div>
        </div>
      </div>
    </Col>
  );
};
export default BlogCard;
